import { useEffect, useState } from "react";
import { LANDING } from "@/constants/testIds";
import { fetchLandingPages } from "@/lib/api";

export default function Footer({ handlers }) {
  const { openMeeting, openBulk } = handlers || {};
  const [budgetPages, setBudgetPages] = useState([]);
  const [cityPages, setCityPages] = useState([]);

  useEffect(() => {
    let alive = true;
    fetchLandingPages()
      .then((list) => {
        if (!alive || !Array.isArray(list)) return;
        setBudgetPages(list.filter((p) => p.type === "budget"));
        setCityPages(list.filter((p) => p.type === "city"));
      })
      .catch(() => { /* silent — columns simply won't render */ });
    return () => { alive = false; };
  }, []);
  return (
    <footer className="utsah-footer">
      <div className="footer-top">
        <div className="footer-brand-stack">
          <div className="footer-brand">
            <a href="/" className="footer-logo" aria-label="Utsah — home"><img src="/brand/utsah-logo.png" alt="Utsah" className="footer-logo-img" /></a>
            <div className="footer-tag">
              Celebrate every moment with meaningful gifts.
            </div>
          </div>
          <div className="footer-col">
            <div className="footer-col-title">Resources</div>
            <ul>
              <li><a href="/resources">Articles</a></li>
            </ul>
          </div>
          <div className="footer-col">
            <div className="footer-col-title">Legal</div>
            <ul>
              <li><a href="/terms-of-service">Terms of Service</a></li>
              <li><a href="/privacy-policy">Privacy Policy</a></li>
              <li><a href="/return-refund-policy">Return &amp; Refund Policy</a></li>
            </ul>
          </div>
        </div>

        {budgetPages.length > 0 && (
          <div className="footer-col" data-testid="footer-budget-col">
            <div className="footer-col-title">Diwali Corporate Gifts by Budget</div>
            <ul>
              {budgetPages.map((p) => (
                <li key={p.id}>
                  <a href={`/collections/${p.slug}`} data-testid={`footer-budget-${p.slug}`}>{p.footer_label}</a>
                </li>
              ))}
            </ul>
          </div>
        )}

        {cityPages.length > 0 && (
          <div className="footer-col" data-testid="footer-city-col">
            <div className="footer-col-title">Diwali Corporate Gifts by City</div>
            <ul>
              {cityPages.map((p) => (
                <li key={p.id}>
                  <a href={`/collections/${p.slug}`} data-testid={`footer-city-${p.slug}`}>{p.footer_label}</a>
                </li>
              ))}
            </ul>
          </div>
        )}

        <div className="footer-col utsah-nav-col">
          <div className="footer-col-title">Utsah</div>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/our-story">Our Story</a></li>
            <li><a href="/partner-benefits">Partner Benefits</a></li>
            <li><a href="/diwali-collection">Diwali Collection</a></li>
            <li><a href="#give-back">The Green Gift</a></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="footer-copy">© 2026 Utsah Gifting. All rights reserved.</div>
        <div className="footer-social">
          <a href="https://www.linkedin.com/company/utsah-gifting/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20.5 2h-17A1.5 1.5 0 002 3.5v17A1.5 1.5 0 003.5 22h17a1.5 1.5 0 001.5-1.5v-17A1.5 1.5 0 0020.5 2zM8 19H5v-9h3zM6.5 8.25A1.75 1.75 0 118.3 6.5a1.78 1.78 0 01-1.8 1.75zM19 19h-3v-4.74c0-1.42-.6-1.93-1.38-1.93A1.74 1.74 0 0013 14.19a.66.66 0 000 .3V19h-3v-9h2.9v1.3a3.11 3.11 0 012.7-1.4c1.55 0 3.36.86 3.36 3.66z" />
            </svg>
          </a>
          <a href="mailto:atishaya@utsahgifting.com" aria-label="Email">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
              <rect x="2" y="4" width="20" height="16" rx="2" />
              <path d="M22 6l-10 7L2 6" />
            </svg>
          </a>
        </div>
      </div>
    </footer>
  );
}
